export default __webpack_public_path__ + "static/media/profile_10.44ed0e9c.jpg";